var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservedSlotAsset16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5643",
    "data-name": "Group 5643",
    transform: "translate(7220 2593)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21499",
    "data-name": "Ellipse 21499",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(-7219 -2592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_46",
    "data-name": "Exclusion 46",
    d: "M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM5.445,3.122a.963.963,0,0,0-.96,1.029v7.555a1.007,1.007,0,0,0,1,.933.982.982,0,0,0,1-.933V9.239H7.4l1.814,2.99a.938.938,0,0,0,.8.411.994.994,0,0,0,.5-.137,1.029,1.029,0,0,0,.475-.65.83.83,0,0,0-.1-.653L9.353,8.992a2.939,2.939,0,0,0,2.126-2.821A2.971,2.971,0,0,0,8.343,3.122Zm2.839,4.43h-1.8V4.891H8.343a1.247,1.247,0,0,1,1.143,1.33,1.257,1.257,0,0,1-1.2,1.33Z",
    transform: "translate(-7220 -2593)",
    fill: "#a0a09f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservedSlotAsset16);
export default __webpack_public_path__ + "static/media/reserved_slot_asset_16.2f972c1d219ad1af511ca2932ba3752d.svg";
export { ForwardRef as ReactComponent };